const a="available",l="unavailable";export{a as AVAILABLE,l as UNAVAILABLE};
